export default __webpack_public_path__ + "static/media/marcin-gorny.ba0ece96.jpeg";